const cls = "underline decoration-foreground/30 underline-offset-2 hover:text-foreground";

const A = ({ href, children, inLink }) => {
  if (!href) return <span>{children}</span>;
  const external = !href.startsWith("/");
  if (inLink) {
    const open = (e) => { e.preventDefault(); e.stopPropagation(); window.open(href, external ? "_blank" : "_self", "noopener"); };
    return <span role="link" tabIndex={0} onClick={open} onKeyDown={(e) => e.key === "Enter" && open(e)} className={`cursor-pointer ${cls}`}>{children}</span>;
  }
  return <a href={href} target={external ? "_blank" : undefined} rel="noreferrer" className={cls}>{children}</a>;
};

// TASL caption, always shown below the image: title, author, source, licence (+link), changes
export const PhotoCredit = ({ credit, className = "", testid = "photo-credit", inLink = false }) => {
  if (!credit || typeof credit !== "object") return null;
  return (
    <span className={`block text-[0.66rem] leading-snug text-muted-foreground ${className}`} data-testid={testid}>
      {credit.symbolic && <>Symbolfoto {credit.symbolic} · </>}{credit.title && <>„{credit.title}“ · </>}Foto: {credit.author} · Quelle: <A href={credit.source_url} inLink={inLink}>{credit.source}</A> · Lizenz: <A href={credit.license_url} inLink={inLink}>{credit.license}</A>
      {credit.changes && <> · {credit.changes}</>}
    </span>
  );
};
